<div class="row" *ngIf="data; else loading">
  <div class="col-12" *ngFor="let rowsByDate of mappedData">
    <h3>
      <span translate>ESTIMATED_DELIVERY_DATE</span> {{ rowsByDate.date | date : 'yyyy-MM-dd' : userTimezone }} -
      <!-- {{rowsByDate.weight | number: '1.0-2'}}kg -  -->
      {{ rowsByDate.volume | number : '1.0-2' }}m³ - {{ rowsByDate.grossWeight | number : '1.0-2' }}kg -
      {{ rowsByDate.netWeight | number : '1.0-2' }}kg - {{ rowsByDate.amount | number : '1.0' }}pcs -
      <lib-price [price]="rowsByDate.totalSales" [currency]="rowsByDate.currency"></lib-price>
    </h3>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th translate>ORDER_ID</th>
            <th translate>CUSTOMER_ORDER_ID</th>
            <th translate>PRODUCT_ID</th>
            <th translate>NAME</th>
            <th translate>ESTIMATED_DELIVERY_DATE</th>
            <th translate>QUANTITY</th>
            <th translate>QUANTITY_DELIVERED</th>
            <th translate>QUANTITY_BACKORDER</th>
            <!-- <th translate>UNIT_PRICE</th> -->
            <!-- <th translate>DISCOUNT</th> -->
            <!-- <th translate>TOTAL_PRICE</th> -->
            <th translate>WEIGHT</th>
            <th translate>VOLUME</th>
            <th>
              <!-- INFORMATION -->
            </th>
            <th>
              <!-- EDIT BUTTON -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rowsByDate.rows" [ngClass]="row.extra.orp.ordradst === 90 ? 'deleted' : ''">
            <td>
              <a routerLink="/orders/{{ row.orderId }}">{{ row.orderId }}</a>
            </td>
            <td>
              <span *ngIf="row.extra.orp.kundbestnr">
                {{ row.extra.orp.kundbestnr }}
              </span>
            </td>
            <td>
              <a routerLink="/product/{{ row.productId }}">{{ row.productId }}</a>
            </td>
            <td>
              <a routerLink="/product/{{ row.productId }}">
                <span *ngIf="row.extra.orp.artbeskr">
                  {{ row.extra.orp.artbeskr }}
                </span>
              </a>
            </td>
            <td>
              {{ row.extra.orp.ordberlevdat | date : 'yyyy-MM-dd' : '+100' }}
            </td>
            <td>
              {{ row.quantity }}
            </td>
            <td>
              {{ row.extra.orp.ordlevantal }}
            </td>
            <td>
              {{ row.extra.orp.ordrestant }}
            </td>
            <!-- <td>
              <lib-price [price]="row.extra.orp.vb_pris" [currency]="row.extra.orp.invaluta"></lib-price>
            </td> -->
            <!-- <td>
              {{row.extra.orp.kundrabatt | number : '1.0-2'}}%
            </td> -->
            <!-- <td>
              <lib-price [price]="row.extra.orp.vbordradsum" [currency]="row.extra.orp.invaluta"></lib-price>
            </td> -->
            <td>
              {{ row.extra.orp.q_3d_bruttovikt || row.product?.extra.ar.artbtotvikt | number : '1.4-4' : 'en-US' }}
            </td>
            <td>
              {{ row.extra.orp.q_3d_volym || row.product?.extra.ar.artvolym | number : '1.4-4' : 'en-US' }}
            </td>
            <td>
              <i
                *ngIf="selectedLanguageCode && row.product?.extra.i18n[selectedLanguageCode]?.transportInfo"
                class="fal fa-exclamation-triangle ml-auto"
                ngbTooltip="{{ row.product.extra.i18n[selectedLanguageCode].transportInfo }}"
              ></i>
            </td>
            <td>
              <button *ngIf="!!row.extra._isEditable" class="btn btn-primary" (click)="openEditModal(row)" translate>
                EDIT
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #loading translate> LOADING <i class="fa fa-spinner fa-spin fa-7x"></i> </ng-template>
